export * from './app-header.component';



// WEBPACK FOOTER //
// ./src/app/shared/app-header/index.ts